// Track the last event timestamp to prevent duplicates
let lastEventTimestamp = 0;

/**
 * Some portal roots are used in input components, and we need to send clicks through them so that
 * the click is not considered to be an outside click.
 * This function handles that.
 *
 * @param {MouseEvent} e - The mouse event
 * @param {() => void} callback - The callback to call when the click is outside the opener
 */
const handleClickInPortal = (e: MouseEvent, callback: () => void): void => {
  const portalRoots = {
    dropdown: document.getElementById('dropdown-portal-root'),
    datePicker: document.getElementById('date-picker-root'),
  };

  if (isTargetInPortal(portalRoots.dropdown, e.target as Node)) {
    const clickEvent = createClickEvent(e);
    if (clickEvent && lastEventTimestamp !== e.timeStamp) {
      (e.target as Node).dispatchEvent(clickEvent);
    }
    return;
  }

  if (isTargetInPortal(portalRoots.datePicker, e.target as Node)) {
    const clickEvent = createClickEvent(e);
    if (clickEvent && lastEventTimestamp !== e.timeStamp) {
      (e.target as Node).dispatchEvent(clickEvent);
    }
    return;
  }

  callback();
};

export default handleClickInPortal;

const createClickEvent = (e: MouseEvent) => {
  if (e == null || e.timeStamp === lastEventTimestamp) {
    return;
  }

  lastEventTimestamp = e.timeStamp;

  return new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  });
};

const isTargetInPortal = (root: HTMLElement | null, target: Node) =>
  root && root.contains(target);
